import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { formatNumber } from 'libraries/utils'

const EditWineNoteDialog = props => {
    const { t } = useTranslation();
    const { form, open, onClose, onSaveNote, data, currencyList } = props
    const [currency, setCurrency] = useState(data.currencyRaw)
    
    const { getFieldProps, getFieldError } = form

    const onCurrencyChange = (event) => {
        setCurrency(event.target.value)
    }

    const onSave = () => {
        form.validateFields((error, value) => {
            if (!error) {
                onSaveNote(value.cost, currency, value.note)
            }
        })
    }

    return (
        <Dialog className="dialog" open={open} onClose={onClose} fullWidth>
            <DialogTitle disableTypography style={{ padding: '32px 32px 20px' }}>
                <Grid container justify="space-between" alignItems="center">
                    <Typography style={{ fontSize: '20px' }}>{t('edit_member_wine')}</Typography>
                    <CloseIcon className="dialog-close" onClick={onClose} />
                </Grid>
            </DialogTitle>
            <div className="d-flex align-items-center" style={{ margin: '15px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogContent>
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Grid item xs={3}>
                        <Typography className="text-grey text-center" >
                            {t('unit_price')}
                        </Typography>
                    </Grid>
                    <Grid item container xs={9}>
                        <Grid item container xs={3}>
                            <Select
                                style={{ marginRight: '25px' }}
                                variant="filled"
                                value={currency}
                                onChange={onCurrencyChange}
                                disableUnderline
                            >
                                {currencyList.map(currency => (
                                    <MenuItem key={currency} value={currency}>{currency}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item md={3}>
                            <Grid container alignItems="center">
                                <TextField
                                    margin="dense"
                                    name="cost"
                                    id="cost"
                                    variant="outlined"
                                    fullWidth
                                    inputProps={{
                                        ...getFieldProps('cost', {
                                            initialValue: Number(data.unitCostRaw),
                                            rules: [{
                								type: 'string',
                								pattern: /^[0-9]*$/,
                                            }]
                                        })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container style={{ marginBottom: '10px' }}>
                    <Grid item xs={3} style={{ paddingTop: '10px' }}>
                        <Typography className="text-grey text-center">
                            {t('purchase_note')}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            margin="dense"
                            name="note"
                            id="note"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows="3"
                            placeholder='這一批藏酒的購買地點以及相關資訊可以記錄在這裡'
                            inputProps={{
                                ...getFieldProps('note', {
                                    initialValue: props.note,
                                    rules: [{
                                        type: "string"
                                    }]
                                })
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <div className="d-flex align-items-center" style={{ margin: '0px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogActions className="dialog-func">
                <Grid container justify="flex-end" alignItems="center">
                    <Button color="primary" variant="contained" onClick={onSave}>
                        {t('save')}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default createForm()(EditWineNoteDialog)